// extracted by mini-css-extract-plugin
export default {"badge":"NeutralBadge_badge__I+vVE","amount":"NeutralBadge_amount__sLe-B"};